import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        outerContainer: {
            layerStyle: 'full-width',
            paddingLeft: {base: remCalc(16), xl: 0},
            paddingRight: {base: remCalc(16), xl: 0},
            paddingTop: 'medium.base',
            paddingBottom: 'medium.base',
            width: '100%',
            overflowX: 'auto',
            flexShrink: 0,
            flexDir: 'column',
        },
        innerContainer: {
            width: '100%',
            flexDir: 'column',
        },
        productsContainer: {
            flexDir: {base: 'column', lg: 'row'},
        },
        headerLabel: {
            py: {
                base: remCalc(16),
                md: remCalc(40),
            },
            paddingRight: {
                base: remCalc(16),
                md: 0,
            },
            position: 'sticky',
            textStyle: 'head-large',
            fontWeight: '500',
        },
        bundleCard: {
            flexDir: {base: 'column-reverse', lg: 'row'},
            alignItems: 'center',
            w: {base: '100%', lg: '25%', xl: '25%'},
            marginBottom: {base: remCalc(8), lg: remCalc(0)},
        },
        plusIconContainer: {
            height: '100%',
            display: {base: 'none', lg: 'flex'},
            alignItems: 'center',
            marginLeft: remCalc(15),
            marginRight: remCalc(15),
        },
        plusIconContainerMobile: {
            height: {base: remCalc(40), lg: '100%'},
            display: {base: 'flex', lg: 'none'},
            alignItems: 'center',
            marginLeft: remCalc(15),
            marginRight: remCalc(15),
            marginTop: {base: remCalc(8), lg: 0},
        },
        bundleProductCard: {
            flexDir: {base: 'row', lg: 'column'},
            width: '100%',
            borderRadius: {base: remCalc(4), lg: remCalc(8)},
            height: {base: remCalc(120), lg: 'fit-content'},
            overflow: 'hidden',
            backgroundColor: 'background.default',
            position: 'relative',
        },
        productDetailsContainer: {
            flexDir: {base: 'row', lg: 'column'},
            justifyContent: 'space-between',
            paddingRight: {base: remCalc(8), lg: 0},
            alignItems: 'center',
            gap: {base: remCalc(8), lg: 'unset'},
            flex: '1 0 0',
            mx: 0,
            paddingBottom: {base: 0, lg: remCalc(24)},
            fontWeight: '400',
            backgroundColor: 'background.default',
            width: {base: `calc(100% - ${remCalc(120)})`, lg: '100%'},
        },
        productDetailId: {
            textStyle: 'body-small',
            color: 'text.secondary',
        },
        productDetailNameContainer: {
            w: {base: '100%', lg: '84%'},
        },
        productDetailName: {
            textStyle: 'head-xsmall',
            color: 'text.default',
            'text-wrap': 'auto',
            textAlign: {base: 'left', lg: 'center'},
            marginBottom: {base: remCalc(0), lg: remCalc(20)},
            noOfLines: {base: 2, lg: 1},
            textOverflow: 'ellipsis',
            fontWeight: '500',
            display: {base: '-webkit-box', lg: 'block'},
            whiteSpace: {base: 'normal', lg: 'nowrap'},
        },
        subtotalPrice: {
            justifyContent: {base: 'space-between', lg: 'flex-start'},
            marginBottom: {base: remCalc(20), lg: 0},
            alignItems: 'center',
            fontWeight: '500',
            textStyle: {base: 'head-xsmall', lg: 'head-small'},
        },
        bundleDiscountLabel: {
            w: 'fit-content',
            padding: '6px 8px',
            backgroundColor: '#C9E3F9',
            position: 'absolute',
            right: {base: remCalc(8), lg: '50%'},
            transform: {base: 'translateX(0)', lg: 'translateX(50%)'},
            bottom: {base: remCalc(84), lg: remCalc(105)},
            textStyle: 'body-xsmall',
            fontWeight: '700',
        },
        bundleFreeGiftLabel: {
            backgroundColor: '#0C2340',
            color: 'white',
            padding: '6px 8px',
            textStyle: 'body-xsmall',
            fontWeight: '700',
            whiteSpace: 'nowrap',
        },
        productPriceContainer: {
            flexDir: {base: 'column', lg: 'row'},
            w: {base: '100%', lg: 'auto'},
            alignItems: {base: 'flex-end', lg: 'center'},
            gap: {base: remCalc(5), lg: remCalc(10)},
        },
        productDetailPrice: {
            textStyle: 'body-xlarge',
            color: 'text.default',
            fontWeight: 'normal',
            order: 2,
            marginLeft: remCalc(6),
        },
        productListPrice: {
            textStyle: 'body-large',
            color: 'text.secondary',
            fontWeight: 'normal',
            order: 1,
        },
        addCartButtonContainer: {
            flexDirection: {base: 'column', lg: 'row'},
            justifyContent: 'flex-end',
            marginTop: remCalc(40),
        },
        addCartButton: {
            w: {base: '100%', lg: remCalc(213)},
        },
        cartBundleContainer: {
            w: 'auto',
            height: 'auto',
            display: 'flex',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: {base: remCalc(16), lg: remCalc(24)},
            minWidth: {base: remCalc(150), lg: remCalc(476)},
            border: '2px solid #D4D4D4',
            borderRadius: 'medium.lg',
        },
        cartHeaderContainer: {
            backgroundColor: 'background.light',
            w: '100%',
            padding: [remCalc(16), remCalc(16), remCalc(16), remCalc(24)],
            display: 'flex',
            justifyContent: 'space-between',
        },
        cartHeaderInfoContainer: {
            display: 'flex',
            flexDirection: 'column',
        },
        cartHeaderPriceContainer: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(16),
        },
        cartBundleName: {
            textStyle: 'body-xxlarge',
            fontWeight: 400,
        },
        cartBundleItemContainer: {
            w: '100%',
            display: 'flex',
            alignItems: 'flex-start',
            gap: {base: remCalc(24), lg: remCalc(26)},
            bg: 'background.default',
            borderBottom: 'small',
            borderStyle: 'solid',
            borderColor: 'border.light',
            paddingBottom: {base: remCalc(20), lg: 0},
            paddingRight: remCalc(8),
        },
        cartBundleItemImage: {
            width: {
                lg: remCalc(212),
                md: remCalc(109),
                sm: remCalc(109),
                base: remCalc(109),
            },
            height: {
                lg: remCalc(212),
                md: remCalc(109),
                sm: remCalc(109),
                base: remCalc(109),
            },
        },
        cartItemDetailContainer: {
            display: 'flex',
            w: '100%',
            flexDir: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
        },
        cartItemHeaderStack: {
            display: 'flex',
            justifyContent: 'space-between',
            alignSelf: 'stretch',
        },
        cartItemOmniAndPrice: {
            display: 'flex',
            flexDir: 'column',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            gap: remCalc(8),
            flexWrap: 'wrap',
        },
        cartItemVatDetails: {
            display: 'flex',
            width: {
                lg: remCalc(164),
                md: remCalc(164),
            },
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: remCalc(10),
        },
        cartItemName: {
            flex: '1 0 0',
            color: 'text.default',
            textStyle: 'head-xsmall',
            fontWeight: 500,
        },
        cartItemPrice: {
            color: 'text.default',
            textStyle: 'body-medium',
            fontWeight: 400,
            textAlign: 'left',
        },
        cartSuggestedPrice: {
            textAlign: 'left',
            textDecorationLine: 'line-through',
            textStyle: 'body-xsmall',
            fontWeight: 400,
            color: 'text.secondary',
        },
        cartSuggestedText: {
            textAlign: 'left',
            textStyle: 'body-xsmall',
            fontWeight: 400,
            color: 'text.secondary',
        },
        infoLabelContainer: {
            flexDir: 'row',
            gap: 'xsmall.base',
            flexWrap: 'wrap',
            justifyContent: 'flex-start',
        },
    },
}
